import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthSessionService } from './auth-session.service';

export function rbacCanMatch(permission: string): CanMatchFn {
  return () => {
    const session = inject(AuthSessionService);
    const router = inject(Router);

    const snap = session.snapshot(); // ✅ signal read

    if (snap.status === 'guest') return router.createUrlTree(['/auth/login']);
    if (snap.status === 'unknown') return true; // allow router to proceed; app will settle later

    // offline-safe: do not hard block if we have no user cached
    if (!snap.user) return true;

    return snap.user.permissions.includes(permission)
      ? true
      : router.createUrlTree(['/no-access']);
  };
}

export function rbacAnyCanMatch(permissions: string[]): CanMatchFn {
  return () => {
    const session = inject(AuthSessionService);
    const router = inject(Router);

    const snap = session.snapshot(); // ✅ signal read

    if (snap.status === 'guest') return router.createUrlTree(['/auth/login']);
    if (snap.status === 'unknown') return true;
    if (!snap.user) return true;

    const set = new Set(snap.user.permissions);
    return permissions.some((p) => set.has(p))
      ? true
      : router.createUrlTree(['/no-access']);
  };
}
